/**
 * RangeSlider - Wrapper around Slider for range selection
 * This is a custom component built on top of shadcn Slider
 */

import * as React from 'react';
import { Slider } from './Slider';

interface RangeSliderProps extends React.ComponentPropsWithoutRef<
  typeof Slider
> {
  value?: number[];
  onValueChange?: (value: number[]) => void;
  min?: number;
  max?: number;
  step?: number;
}

export const RangeSlider = React.forwardRef<
  React.ElementRef<typeof Slider>,
  RangeSliderProps
>(
  (
    { value = [0, 100], onValueChange, min = 0, max = 100, step = 1, ...props },
    ref,
  ) => {
    return (
      <Slider
        ref={ref}
        value={value}
        onValueChange={onValueChange}
        min={min}
        max={max}
        step={step}
        {...props}
      />
    );
  },
);

RangeSlider.displayName = 'RangeSlider';
